import { Classifier } from '../classifier/classifier.model';
import { ScandataModel } from '../scandata/scandata.models';
import { PickerType } from './file-pickers/file-picker.models';

export const ALLOWED_EXTENSIONS = ['.las', '.laz', '.e57'];
export const MAX_IMPORT_FILES = 1000;

export enum ImportStatus {
  NotStarted = 'NotStarted',
  Busy = 'Busy',
  Completed = 'Completed',
  Error = 'Error',
}

export enum ImportScanStatus {
  Initialized = 'Initialized',
  Pending = 'Pending',
  CheckQuota = 'CheckQuota',
  CreatePointcloud = 'CreatePointcloud',
  CreateImport = 'CreateImport',
  CreateFiles = 'CreateFiles',
  UploadFiles = 'UploadFiles',
  Ingest = 'Ingest',
  Completed = 'Completed',
  Error = 'Error',
}

export enum ImportScanError {
  CheckQuota = 'CheckQuota',
  QuotaExceeded = 'QuotaExceeded',
  CreatePointcloud = 'CreatePointcloud',
  CreateImport = 'CreateImport',
  CreateFiles = 'CreateFiles',
  UploadFiles = 'UploadFiles',
  Ingest = 'Ingest',
}

export interface ImportScan {
  id: string;
  name: string;
  classifier?: Classifier;
  files: ImportFile[];
  status: ImportScanStatus;

  scan?: ScandataModel;
  error?: ImportScanError;
}

export enum ImportFileStatus {
  Pending = 'Pending',
  Busy = 'Busy',
  Completed = 'Completed',
  Error = 'Error',
  Skipped = 'Skipped',
}

export interface ImportFile {
  id: string;
  name: string;
  size: number;
  pickerType: PickerType;

  downloadUrl?: string;
  downloadToken?: string;
  externalFileId?: string;
  alreadyIngested?: boolean;

  statusMessage?: string;
  status?: ImportFileStatus;
  fileUpload?: {
    file: File;
    uploadUrl?: string;
    progress?: number;
    startTime?: Date;
    transferred?: number;
  };
}
